import { useCallback } from 'react'
import { useDropzone, DropzoneState } from 'react-dropzone'

export const useBulkUploadDropzone = (
    onFileSelect: (file: File) => void,
): DropzoneState => {
    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            if (acceptedFiles.length > 0) {
                onFileSelect(acceptedFiles[0])
            }
        },
        [onFileSelect],
    )

    return useDropzone({
        onDrop,
        accept: {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                ['.xlsx'],
        },
        maxFiles: 1,
    })
}
